import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { type AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { processEvent, processPendingEvent } from '../core/processEvent'
import { type AnalyticsEvents } from '../types/events'

export interface UseAnalyticsArgs {
  defaultPlatforms?: AnalyticsPlatforms[]
}

export const useAnalytics = (args?: UseAnalyticsArgs) => {
  const { defaultPlatforms = [] } = args || {}

  const sendEvent = useCallbackEvent((
    customEvent: AnalyticsEvents,
    platforms: AnalyticsPlatforms[] = [],
  ) => {
    const dedupePlatforms: AnalyticsPlatforms[] = [...new Set([...defaultPlatforms, ...platforms])]
    processEvent({
      event: customEvent,
      platforms: dedupePlatforms.length ? dedupePlatforms : undefined,
    })
  })

  const sendPendingEvent = useCallbackEvent((
    customEvent: AnalyticsEvents,
    platforms: AnalyticsPlatforms[] = [],
  ) => {
    const dedupePlatforms: AnalyticsPlatforms[] = [...new Set([...defaultPlatforms, ...platforms])]
    processPendingEvent({
      event: customEvent,
      platforms: dedupePlatforms.length ? dedupePlatforms : undefined,
    })
  })

  return {
    sendEvent,
    sendPendingEvent,
  }
}
